var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBagFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    stroke: props.color,
    d: "M3 7v15h18V7H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M7.5 7V4.5C7.5 3 10 2 12 2s4.5 1 4.5 2.5V7"
  }));
}
export default SvgIconBagFill;